module.exports = __webpack_public_path__ + "assets/MaterialIcons-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/material-icons/iconfont/MaterialIcons-Regular.eot
// module id = 949
// module chunks = 1